import { MDBBtn, MDBCol } from "mdb-react-ui-kit";
import { FC, useState } from "react";
import userInterfaceSvg from "@/utils/svg-icon/userInterface";
import styles from "@/styles/Footer.module.scss";

const ButtonCta: FC<{
    placeholder: string;
    isSmall: boolean;
    onClick: (value: string) => void;
    className?: string;
    isDisable?: boolean;
    inputType?: string;
    validator?: (value: string) => boolean;
}> = ({
    placeholder,
    isSmall,
    onClick,
    className = "",
    isDisable = false,
    inputType = "text",
    validator = () => true,
}) => {
    const [text, setText] = useState("");

    const { ArrowRightLine } = userInterfaceSvg;

    return (
        <div className={`${styles.footInputContainerBtnCta}  ${className}`}>
            <MDBCol size={9}>
                <input
                    type={inputType}
                    placeholder={placeholder}
                    value={text}
                    className={`${styles.footInputCTABtn} d-block w-100`}
                    onChange={e => setText(e.target.value)}
                />
            </MDBCol>
            <MDBCol
                className={`d-inline-flex flex-row-reverse ${
                    isSmall ? "px-2" : ""
                }`}
            >
                <MDBBtn
                    tag="a"
                    floating
                    className={`${styles.footInputButton} shadow-0`}
                    disabled={isDisable || !validator(text)}
                    onClick={() => {
                        setText("");
                        onClick(text);
                    }}
                >
                    <ArrowRightLine />
                </MDBBtn>
            </MDBCol>
        </div>
    );
};

export default ButtonCta;
